module.exports = __webpack_public_path__ + "img/EmptySearch.9da5afd1.svg";